import { graphql } from '@/gql';

import './optionFieldsFragment';
import './valueFieldsFragment';

graphql(`
  fragment MultiOrderPartialDetailedFragment on PaginatedDeliveryOrderResponse {
    count
    rows {
      id
      callerId
      caller {
        firstName
        lastName
        phoneNumber
        isRequiredMonitoringGourmetOrder
      }
      orderId
      preferredPhoneNumber
      clientName
      operatorId
      isRedelivery
      originalOrderId
      natureOfComplaint
      operator {
        firstName
        lastName
      }
      scheduleId
      total
      service
      serviceAccount {
        email
        password
        phoneNumber
      }
      storeOrder {
        title
        subtitle
        phoneNumber
        address {
          formattedAddress
        }
        estimate {
          total
          serviceEstimateReference
          charges {
            title
            value
            originalValue
            tooltips {
              title
              value
            }
          }
          timeEstimate {
            min
            max
          }
          chargeOptions {
            plan
            tier
            applyDiscountedFee
            noServiceFee
            doNotCharge
            chargeNow
            reason
          }
          address {
            formattedAddress
            placeId
            latitude
            longitude
            name
            streetNumber
            postalCode
            streetAddress
            streetAddress2
            state
            city
            country
          }
          promotion {
            promotionUuid
            text
            description
          }
          orderOptions {
            storeInstructions
            deliveryInstructions
            dropoffOptionId
          }
          items {
            item {
              title
              price
              quantity
            }
            options {
              ...OptionsFields
              values {
                ...ValuesFields
                subOptions {
                  ...OptionsFields
                  values {
                    ...ValuesFields
                    subOptions {
                      ...OptionsFields
                      values {
                        ...ValuesFields
                        subOptions {
                          ...OptionsFields
                          values {
                            ...ValuesFields
                            subOptions {
                              ...OptionsFields
                              values {
                                ...ValuesFields
                                subOptions {
                                  ...OptionsFields
                                  values {
                                    ...ValuesFields
                                    subOptions {
                                      ...OptionsFields
                                      values {
                                        ...ValuesFields
                                        subOptions {
                                          ...OptionsFields
                                          values {
                                            ...ValuesFields
                                            subOptions {
                                              ...OptionsFields
                                              values {
                                                ...ValuesFields
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      orderStatus {
        currentProgress
        title
        subtitle
        description
        agent {
          phoneNumber
          name
        }
        locationMarkers {
          title
          latitude
          longitude
        }
      }
      relatedPath {
        orderResolution {
          resolvedByOrderID
          resolvedOrderID
          redeliveryByOrderId
          resolvedWithoutReorder
        }
      }
      status
      paidStatus
      isConfirmedMonitoringCall
      rateInfo {
        submittedAt
        submitById
        rateList {
          target {
            targetType
            targetId
          }
          starRating
          reviewText
          tagList {
            tagId
            tagName
          }
        }
      }
      orderCharge {
        total
        card {
          total
          complete
        }
        credits {
          total
          complete
        }
        expiringCredits {
          expiringCreditId
          complete
          total
        }
      }
      transactionId
      isNotReceivedOrder
      needLoveId
      createdAt
      updatedAt
    }
  }
`);
